var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { User } from "@models/user";
import * as Sentry from "@sentry/browser";
import { apiClient, logOut, useUserStore } from "./auth";
export const addUserWallet = (user, wallet) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "addUserWallet",
        level: "info",
    });
    const _user = yield apiClient.post(`/users/${user.id}/wallets`, {
        network: wallet.network,
        address: wallet.address,
        provider: wallet.provider,
    });
    if (!_user)
        return false;
    Sentry.setUser({
        authId: _user.authId,
        email: _user.email,
        address: wallet.address,
    });
    useUserStore.setState({ user: new User(_user) });
    return true;
});
export const removeUserWallet = (user, wallet) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "removeUserWallet",
        level: "info",
    });
    const _user = yield apiClient.del(`/users/${user.id}/wallets`, {
        network: wallet.network,
        address: wallet.address,
    });
    if (!_user)
        return false;
    Sentry.setUser({
        authId: _user.authId,
        email: _user.email,
        address: wallet.address,
    });
    useUserStore.setState({ user: new User(_user) });
    return true;
});
export const deleteUser = (user) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "deleteUser",
        level: "info",
    });
    Sentry.setUser({
        authId: user.authId,
        email: user.email,
        address: user.walletAddresses.join(","),
    });
    const _user = yield apiClient.del(`/users/${user.id}`);
    if (!_user)
        return false;
    useUserStore.setState({ user: null });
    return logOut();
});
